import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  history: [],
};
const urlHistorySlice = createSlice({
  name: "urlHistory",
  initialState,
  reducers: {
    addToHistory: (state, action) => {
      const path = action.payload.pathname;
      const endpoint = path.split("/").filter(Boolean).pop() || "";
      const arrayOfPaths = action.payload.baseEndPointArray;
      if (path === state.history[state.history.length - 1]) {
        return;
      }
      if (arrayOfPaths.includes(endpoint)) {
        state.history = [path];
        return;
      }
      const existingIndex = state.history.indexOf(path);
      if (existingIndex !== -1) {
        state.history = state.history.slice(0, existingIndex + 1);
      } else {
        state.history.push(path);
      }
    },
    clearHistory: (state) => {
      state.history = [];
    },
    removeLastFromHistory: (state) => {
      state.history.pop();
    },
    returnArrayUpToIndex(state, action) {
      index = action.payloadindex;
      state.history = state.history.slice(0, index + 1);
    },
  },
});

export const { addToHistory, clearHistory, removeLastFromHistory } =
  urlHistorySlice.actions;
export default urlHistorySlice.reducer;
